import { render, staticRenderFns } from "./OrderTracking.vue?vue&type=template&id=2eb998ac&scoped=true&"
import script from "./OrderTracking.vue?vue&type=script&lang=js&"
export * from "./OrderTracking.vue?vue&type=script&lang=js&"
import style0 from "./OrderTracking.vue?vue&type=style&index=0&id=2eb998ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb998ac",
  null
  
)

export default component.exports